import type { Components, Theme } from '@mui/material';

export const MuiAccordion: Components<Omit<Theme, 'components'>>['MuiAccordion'] = {
  defaultProps: {
    disableGutters: true,
    elevation: 0,
    square: true,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: theme.shape.borderRadius,
      '&:not(:last-child)': {
        borderBottom: 0,
      },
      '&:before': {
        display: 'none',
      },
    }),
  },
};
